module.exports = __webpack_public_path__ + "img/1.f84c4fe6.png";